export default __webpack_public_path__ + "static/media/img-0517-croatia-premium-face.74ca1025.png";